define("settings/controllers/overview/downgrade", ["exports", "@ember/controller", "@ember/object", "@ember/service", "@glimmer/tracking"], function (_exports, _controller, _object, _service, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let DowngradeController = _exports.default = (_class = class DowngradeController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "router", _descriptor4, this);
      _initializerDefineProperty(this, "initialHasOverageLinkinbioPages", _descriptor5, this);
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get initialHasOverageGroups() {
      return this.overageGroups > 0;
    }
    get initialHasOverageSocialSets() {
      return this.overageSocialSets > 0;
    }
    get initialHasOverageUsers() {
      return this.overageUsers > 0;
    }
    get overageGroups() {
      return this.upcomingOverages?.clusters;
    }
    get overageLinkinbioPages() {
      return this.currentAccount.linkinbioPagesOverage;
    }
    get overageSocialSets() {
      return this.currentAccount?.setsOverages;
    }
    get overageUsers() {
      return this.upcomingOverages?.users;
    }
    get upcomingOverages() {
      return this.currentAccount.upcomingOverages;
    }
    organizeSocialProfiles() {
      this.dialogManager.confirm(this.intl.t('account.downgrade.social_sets.organize.confirm_dialog'), {
        description: this.intl.t('account.downgrade.social_sets.organize.description'),
        confirmButton: this.intl.t('account.downgrade.social_sets.organize.confirm_btn')
      }).then(() => {
        this.router.transitionTo('account.groups.trade');
      });
    }
    updateInitialHasOverageLinkinbioPages(linkinbioPages) {
      this.initialHasOverageLinkinbioPages = linkinbioPages.length > this.currentAccount.socialSetCount;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "initialHasOverageLinkinbioPages", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return this.overageLinkinbioPages > 0;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "organizeSocialProfiles", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "organizeSocialProfiles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateInitialHasOverageLinkinbioPages", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialHasOverageLinkinbioPages"), _class.prototype)), _class);
});